import Header from '@allesauto/core/header';
import translate from '@allesauto/i18n';
import { CloudServiceManagement32 } from '@carbon/icons-react';
import React from 'react';
import { useIntl } from 'react-intl';

const MaintenanceComponent = () => {
  const intl = useIntl();

  return (
    <div>
      <Header isSimpleHeader />
      <div className="bg-white flex flex-col generic-error-content h-[calc(100vh_-_60px)] items-center justify-center w-full md:h-[calc(100vh_-_70px)]">
        <div className="h-[150px] mb-[50px] md:mb-60px">
          <div className="bg-[#e8114d] flex h-[128px] items-center justify-center rounded-circle w-[128px]">
            <CloudServiceManagement32 className="fill-[#930a32] h-[50px] w-[50px]" />
          </div>
        </div>
        <div className="flex flex-col justify-center sm:ml-30px sm:mr-30px">
          <h2 className="pb-5px text-center text-headline1 md:pb-10px">
            {translate(intl, 'ui.MAINTENANCE.TITLE')}
          </h2>
          <p className="pb-20px text-center md:pb-30px">
            {translate(intl, 'ui.MAINTENANCE.DESCRIPTION')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceComponent;
